// @ts-nocheck
import React, { useMemo, useRef } from 'react'
import { useModuleContext } from '../../contexts/EventsContext'
import usePush from '../../hooks/usePush'
import { Dropdown } from '@mch-group/uikit-components'

// Filter usually titled in screen as "Type"
const TypeFilter = () => {
  const [{ labels, router }] = useModuleContext()
  const routerQuery = router.query

  const { pushFullChange } = usePush()

  // The 3 options in the Dropdown
  // Complexity in this filters, is that what is that the value in the option is not what is sent to URL.
  const options = useMemo(
    () => [
      { value: 'events', label: labels && labels.Events.browseFilterAllEvents, id: 23333 },
      { value: 'exhibitions', label: labels && labels.Events.browseFilterAllExhibitions, id: 23334 },
      { value: 'virtual', label: labels && labels.Events.allVirtualEventsFilterLabel, id: 23335 }
    ].filter(item => item.label && item.label !== '---'),
    [labels]
  )

  const dropdownSelectionRef = useRef(null)

  const prepareForDropdownFormat = (query) => {
    const output = []

    if (query.allTypes === 'true') {
      output.push('events')
      output.push('exhibitions')
      output.push('virtual')
    } else if (query.virtual === 'false' && query.exhibition === 'false') {
      output.push('events')
    } else if (query.virtual === 'true' && query.exhibition === 'false') {
      output.push('virtual')
    } else if (query.exhibition === 'true') {
      output.push('exhibitions')
    } else if (query.exhibition === 'false') {
      output.push('events')
      output.push('virtual')
    } else if (query.virtual === 'false') {
      output.push('events')
      output.push('exhibitions')
    } else if (query.physicalEvent === 'false') {
      output.push('virtual')
      output.push('exhibitions')
    }
    dropdownSelectionRef.current = output
    return output
  }

  const dropdownOptions = prepareForDropdownFormat(routerQuery)

  return (
    <Dropdown
      className='mb-9 mb-md-10 mb-lg-0 mb-xl-0 mb-xxl-0'
      label={dropdownOptions.length > 0 ?
        `${dropdownOptions.length} ${labels.Events.browseFilterSelected}` : labels.Events.browseFilterAll}
      variant='multiple'
      options={options}
      isMultiselect
      onChange={(value) => {
        // Delete any of the active filters (but don't touch those from the rest of filters of the page)
        const routerQueryCopy = { ...routerQuery }
        delete routerQueryCopy.exhibition
        delete routerQueryCopy.virtual
        delete routerQueryCopy.physicalEvent
        delete routerQueryCopy.allTypes
        if (value.includes('exhibitions') && value.includes('events') && value.includes('virtual')) {
          routerQueryCopy.allTypes = 'true'
        } else if (value.includes('events') && value.includes('virtual')) {
          routerQueryCopy.exhibition = 'false'
        } else if (value.includes('events') && value.includes('exhibitions')) {
          routerQueryCopy.virtual = 'false'
        } else if (value.includes('virtual') && value.includes('exhibitions')) {
          routerQueryCopy.physicalEvent = 'false'
        } else if (value.includes('exhibitions')) {
          routerQueryCopy.exhibition = 'true'
        } else if (value.includes('virtual')) {
          routerQueryCopy.virtual = 'true'
          routerQueryCopy.exhibition = 'false'
        } else if (value.includes('events')) {
          routerQueryCopy.virtual = 'false'
          routerQueryCopy.exhibition = 'false'
        }
        // Pushes the filters (all of them, including those from other page filters)
        pushFullChange(routerQueryCopy)
      }}
      value={[...dropdownOptions] || []}
    />
  )
}

export default TypeFilter

/*
  As defined in:
  https://jira.dminc-gtc.com/browse/MCHMFP-714

  All (default) -> No params required
  Events (physical)                 -> virtual=false & isExhibition=false DONE
  Virtual Events                    -> virtual=true & isExhibition=false DONE
  Exhibitions                       -> isExhibition=true
  Events (physical), Virtual Events -> isExhibition=false
  Virtual Events, Exhibitions       -> Cannot be represented with current params. virtual=true would exclude exhibitions
      (which are physical). isExhibition=true would exclude virtual events.
  Events (physical), Exhibitions    -> virtual=false
  Events (physical), Exhibitions, Virtual Events -> No params required (same as All).

  In order to cover for the missing combination we would need a new parameter, something like "physicalEvent" which can
  be true, false or empty, in which case physicalEvent=false would cover this scenario. A PhysicalEvent would be an
  event which is not an exhibition and is not virtual. Case #2 could also be covered with physicalEvent=true, it would
  be equivalent to virtual=false & isExhibition=false.
*/

